import * as i0 from "@angular/core";
/**
 * Base class for a component that represents an item that can be in a folder.
 */
export class FolderableBase {
    get itemUrl() {
        return null;
    }
    get enableItemUrl() {
        return false;
    }
    openInNewTab() {
        if (!this.itemUrl)
            return;
        // eslint-disable-next-line no-unused-expressions
        window.open(this.itemUrl, '_blank')?.focus();
    }
}
FolderableBase.ɵfac = function FolderableBase_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableBase)(); };
FolderableBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableBase });
